import { useEffect, useRef } from "react";


export default function WebsiteItem({webName, fade}) {

  const iframeRef = useRef(null);

  useEffect(()=>{
    if(!iframeRef.current) return;
    const iframe = iframeRef.current;
    iframe.onload = () => {
      const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
  
      // Hide scrollbars inside the iframe
      innerDoc.documentElement.style.overflow = "hidden";
      innerDoc.body.style.overflow = "hidden";
    };
  },[iframeRef.current])
  return (
    <div className='subscription_websiteItem' data-aos={fade}>
        <h2 style={{margin:"0"}}>{webName}</h2>
        <div className='subscription_websiteItem_card'>
            <iframe ref={iframeRef} className="subscription_websiteItem_card_iframe" title="website_example" src={`/${webName}`}/>
            <a href={`https://webingo.site/${webName}`} aria-hidden="true" target='_blank'></a>
        </div>
    </div>
  )
}
